( function( $, document, window ) {
	'use strict';

	function combineClass( className, blockId ) {
		return `${className}-${blockId}`;
	}

	function checkOverflow(swiperInstance) {
		const class_name = 'swiper--no-navigation'
		if (swiperInstance.isBeginning && swiperInstance.isEnd) {
			// All slides are visible, add a class to hide navigation
			swiperInstance.el.classList.add( class_name );
		} else {
			// Not all slides are visible, ensure navigation is shown
			swiperInstance.el.classList.remove( class_name );
		}
	}

	$( function() {
		$( '.js-testimonial-collection' ).each( function( index, element ) {
			const blockId = $(this).data('block-id');

			const config = {
				activeClass: 'is-active',
				carouselEl: combineClass( '.js-carousel', blockId ),
				navigationEl: combineClass( '.js-carousel-navigation', blockId ),
				prevEl: combineClass( '.js-carousel-navigation-prev', blockId ),
				nextEl: combineClass( '.js-carousel-navigation-next', blockId ),
			};

			const $navigation = $( config.navigationEl );

			new Swiper( config.carouselEl, {
				direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 'auto',
				loop: false,
				watchOverflow: true,

				navigation: {
					prevEl: config.prevEl,
					nextEl: config.nextEl,
				},

				breakpoints: {
					744: {
						spaceBetween: 30,
					},
					1280: {
						spaceBetween: 64,
					},
				},

				on: {
					init: function () {
						checkOverflow(this);
						//controlsVisibility;
					},
					resize: function () {
						checkOverflow(this);
						//controlsVisibility;
					},
				}
			});
		});
	} );

} )( jQuery, document, window );
